/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import classnames from 'classnames'
import { injectIntl } from 'react-intl'

class Notification extends React.Component {
  static defaultProps = {
    type: 'info',
    title: null,
    message: null,
    timeOut: 5000,
    onClick: () => {
    },
    onRequestHide: () => {
    },
    customClassName: ''
  }

  componentDidMount = () => {
    const { timeOut } = this.props
    if (timeOut !== 0) {
      this.timer = setTimeout(this.requestHide, timeOut)
    }
  }

  componentWillUnmount = () => {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  handleClick = () => {
    const { onClick } = this.props
    if (onClick) {
      onClick()
    }
    this.requestHide()
  }

  requestHide = () => {
    const { onRequestHide } = this.props
    if (onRequestHide) {
      onRequestHide()
    }
  }

  render() {
    const { type, message, intl } = this.props
    let { title } = this.props
    const { messages } = intl

    const className = classnames(['notification', `notification-${type}`, this.props.customClassName])
    title = title ? (<h4 className="title">{title}</h4>) : null
    return (
      <div className={className} onClick={this.handleClick}>
        <div className="notification-message" role="alert">
          {title}
          <div className="message">{messages[`${message}`] || message}</div>
        </div>
      </div>
    )
  }
}

export default injectIntl(Notification)
